import React from 'react';
import { motion } from 'framer-motion';
import { Download, Star, BookOpen } from 'lucide-react';
export function SocialProofBar() {
  return <div className="w-full bg-forest text-parchment py-8 border-y border-sage/30" data-id="element-192">
      <div className="max-w-5xl mx-auto px-4 flex flex-col md:flex-row justify-center items-center gap-8 md:gap-16" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex items-center" data-id="element-194">
          <div className="w-12 h-12 rounded-full bg-sage/20 flex items-center justify-center mr-4" data-id="element-195">
            <Download className="w-6 h-6 text-sage" data-id="element-196" />
          </div>
          <div data-id="element-197">
            <p className="text-2xl font-playfair font-bold" data-id="element-198">500+</p>
            <p className="text-sm text-parchment/70 uppercase tracking-wider" data-id="element-199">
              Descargas
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="flex items-center" data-id="element-200">
          <div className="w-12 h-12 rounded-full bg-amber/20 flex items-center justify-center mr-4" data-id="element-201">
            <Star className="w-6 h-6 text-amber" data-id="element-202" />
          </div>
          <div data-id="element-203">
            <p className="text-2xl font-playfair font-bold" data-id="element-204">
              4.9 <span className="text-amber text-lg" data-id="element-205">★</span>
            </p>
            <p className="text-sm text-parchment/70 uppercase tracking-wider" data-id="element-206">
              Valoración
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex items-center" data-id="element-207">
          <div className="w-12 h-12 rounded-full bg-sage/20 flex items-center justify-center mr-4" data-id="element-208">
            <BookOpen className="w-6 h-6 text-sage" data-id="element-209" />
          </div>
          <div data-id="element-210">
            <p className="text-2xl font-playfair font-bold" data-id="element-211">6</p>
            <p className="text-sm text-parchment/70 uppercase tracking-wider" data-id="element-212">
              Recetas Incluidas
            </p>
          </div>
        </motion.div>
      </div>
    </div>;
}